<template>
  <v-card flat>
    <template v-if="employee.apprentice == true">
      <template v-if="employee && employee.educations && employee.educations.length > 0">
        <h4>{{ $t("labels.education") }}</h4>
        <p>{{ employee.firstName}} {{ $t("settings.certificate-education-info") }}</p>

        <v-expansion-panels class="mt-4 certificate">
          <v-expansion-panel
            v-for="item in employee.educations"
            :key="item.id"
            :aria-label="getProfessionNameById(item.professionId)"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down">
              <div>
                <div class="header-title">
                  {{ 
                    `${ getProfessionNameById(item.professionId) } ${ isOngoingEducation(get(item, 'endDate', '')) ? 
                    $t('settings.certificate-ongoing-education-title') : '' }` 
                  }}
                </div>
                <div class="header-sub-title gray" v-if="item.extendedInfo">
                  {{ $t("labels.education-year") }}
                  {{ item.extendedInfo.examYear || "Ej angivet" }}
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <h6>{{ $t("labels.education-type") }}</h6>
              <p class="machines" v-if="item.type">
                {{ getEducationName(item.type) }}
              </p>
              <h6>{{ $t("labels.education") }}</h6>
              <p v-if="item.extendedInfo">
                {{ item.extendedInfo.program || "Ej angivet" }}
              </p>
              <h6>{{ $t("labels.education-provider") }}</h6>
              <p v-if="item.extendedInfo">
                {{ item.extendedInfo.schoolName || "Ej angivet" }}
              </p>
              <h6>{{ $t("labels.education-year") }}</h6>
              <!-- <p v-if="item.extendedInfo">
                {{ item.extendedInfo.examYear || "Ej angivet" }}
              </p> -->
              <p v-if="isOngoingEducation(get(item, 'endDate', ''))">
                {{ $t('settings.certificate-ongoing-education-text') }}
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>

      <template v-else>
        <MessageBox class="mb-7" type="info">
          <h6>{{ $t("settings.education-missing-title") }}</h6>
          <p>{{ $t("settings.education-missing-text") }}</p>
          <p>
            <a
              href="https://www.byggbranschensyrkesnamnd.se/faq/utbildning-saknas-men-onskar-skaffa-yrkesbevis/"
              target="_blank"
              >{{ $t("settings.education-missing-link") }}</a
            >
          </p>
        </MessageBox>
      </template>
    </template>

    <template v-else>
      <template v-if="employee.tradeCertificates && employee.tradeCertificates.length">
        <h4>{{ $t("settings.certificates-title") }}</h4>
        <p>
          {{
            $t("company.certificate-text", {
              name: `${employee.firstName} ${employee.lastName}`,
            })
          }}
        </p>

        <v-expansion-panels>
          <v-expansion-panel
            v-for="(item, index) in employee.tradeCertificates"
            :key="index"
            :aria-label="$t('labels.existing-applications')"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
              <div>
                <div class="header-title">{{ item.profession.name }}</div>
                <div class="subtitle-2 gray">
                  {{ $t("settings.created-of-BYN") }}
                  {{ getRegionNameById(item.regionId) }} {{ item.issuedOn | date }}
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mt-n2">
              <h6>{{ $t("company.certificate-by") }}</h6>
              <p class="body-2">BYN {{ getRegionNameById(item.regionId) }}</p>

              <h6>{{ $t("company.certificate-date") }}</h6>
              <p class="body-2">{{ item.issuedOn | date }}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>

      <template
        v-if="employee.machineQualifications && employee.machineQualifications.length"
      >
        <h4>{{ $t("company.machine-certificate") }}</h4>
        <p>
          {{
            $t("company.machine-certificate-text", {
              name: `${employee.firstName} ${employee.lastName}`,
            })
          }}
        </p>

        <v-expansion-panels>
          <v-expansion-panel
            v-for="(item, index) in employee.machineQualifications"
            :key="index"
            :aria-label="$t('labels.existing-applications')"
          >
            <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
              <div>
                <div class="header-title">{{ item.machine.name }}</div>
                <div class="subtitle-2 gray">
                  {{ $t("settings.created-of-BYN2") }}
                  {{ getRegionNameById(item.regionId) }} {{ item.issuedOn | date }}
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mt-n2">
              <h6>{{ $t("company.certificate-by") }}</h6>
              <p class="body-2">
                {{ item.issuedBy.firstName ? item.issuedBy.firstName : "" }}
                {{ item.issuedBy.lastName ? item.issuedBy.lastName : "" }}
              </p>
              <h6>{{ $t("company.certificate-date") }}</h6>
              <p class="body-2">{{ item.issuedOn | date }}</p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template
        v-if="
          isDistanceEducationAdministrator($route.params.id) == true ||
          isAdmin($route.params.id) == true
        "
      >
        <template
          v-if="employee.instructorExemptions && employee.instructorExemptions.length"
        >
          <h4>{{ $t("company.instructor-dispensing") }}</h4>
          <p>
            {{
              $t("company.instructor-dispensing-text", {
                name: `${employee.firstName} ${employee.lastName}`,
              })
            }}
          </p>

          <v-expansion-panels>
            <v-expansion-panel
              v-for="(item, index) in employee.instructorExemptions"
              :key="index"
              :aria-label="$t('labels.existing-applications')"
            >
              <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
                <div>
                  <div class="header-title">
                    {{ $t("company.exemption-type") }}: {{ item.profession.name }}
                  </div>
                  <div class="subtitle-2 gray">
                    {{ item.approvedById ? $t("settings.created-of-BYN2") : $t("settings.applied-to-BYN2") }}
                    {{ getRegionNameById(item.regionId) }} {{ item.issuedOn | date }}
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template v-if="item.approvedById">
                  <h6>{{ $t("company.exemption-issued") }}</h6>
                  <p v-if="item && item.issuedBy" class="body-1">
                    {{ item.issuedBy.firstName ? item.issuedBy.firstName : "" }}
                    {{ item.issuedBy.lastName ? item.issuedBy.lastName : "" }}
                  </p>
                </template>
                <h6>{{ $t("company.exemption-for") }}</h6>
                <p class="body-1">
                  {{ $t("company.exemption-type") }}: {{ item.profession.name }}
                </p>
                <template v-if="item.approvedById">
                  <h6>{{ $t("company.exemption-start-date") }}</h6>
                  <p class="body-1">{{ item.issuedOn | date }}</p>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <template v-else>
          <h4>{{ $t("company.instructor-dispensing") }}</h4>
          <p class="pb-5">
            {{
              $t("company.instructor-dispensing-missing", {
                name: `${employee.firstName} ${employee.lastName}`,
              })
            }}
          </p>
        </template>
        <template v-if="!employee.apprentice">
          <ActionButton
            v-if="$route && $route.params"
            @click="
              $nextTick(() => {
                $router.push({
                  name: 'NewExemptionForExistingPerson',
                  params: {
                    company_id: $route.params.id,
                    employee_id: $route.params.employee_id,
                  },
                });
              })
            "
            type="application"
            class="mt-n5 mb-8"
            actionIcon="$sl-add"
            >{{ $t("labels.new-exemption") }}</ActionButton
          >
        </template>
      </template>
      <!-- Company employee exemptions ends here -->

      <template>
        <h4>{{ $t("company.instructor-education") }}</h4>
        <p v-if="employee.readInstructionsOn">
          {{
            $t("company.instructor-education-text", {
              name: `${employee.firstName} ${employee.lastName}`,
            })
          }}
        </p>

        <template v-if="get(employee, 'readInstructionsOn', null)">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header expand-icon="$sl-arrow-down" two-line>
                <div>
                  <div class="header-title">{{ $t("settings.instructions-title") }}</div>
                  <div class="header-sub-title">
                    {{ $t("labels.confimed") }}
                    {{ employee.readInstructionsOn | date }}
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <h6 v-if="employee.readInstructionsOn">
                  {{ $t("labels.confimed") }}
                </h6>
                <p class="body-1" v-if="employee.readInstructionsOn">
                  {{ employee.readInstructionsOn | date }}
                </p>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <template v-else>
          <MessageBox class="mb-7" type="warning">
            <h6>{{ $t("settings.instructions-updated-title") }}</h6>
            <p>
              {{ $t("settings.instructions-updated-info2", { name: employee.firstName }) }}
            </p>
          </MessageBox>
        </template>
      </template>
    </template>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import API from "@/services/api.js";
import find from "lodash/find";
import get from "lodash/get";
import { RulesMixin, CompanyRoles } from "@/components/mixins";
import ActionButton from "@/components/Common/ActionButton";
import MessageBox from "@/components/Common/MessageBox";
import Sugar from "sugar";

const SugarDate = require("sugar/date");
// @group Company
// CompanyEmployeeCertificate component
export default {
  name: "CompanyEmployeeCertificate",

  mixins: [RulesMixin, CompanyRoles],

  data: () => ({
    links: require("../../lib/external-links.json"),
    educationTypes: [],
  }),

  components: {
    ActionButton,
    MessageBox,
  },
  props: {
    // employee object
    emp: {
      // `Object`
      type: Object,
    },
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("basic", [
      "getRegionNameById",
      "getProfessionById",
      "getProfessionNameById",
    ]),
    ...mapGetters("currentuser", [
      "currentUser",
      "isCompanyUser",
      "isAdmin",
      "isAdministrator",
      "isCompanyEducationResponsible",
      "isDistanceEducationAdministrator",
      "isDepartmentAdministrator",
    ])
  },
  methods: {
    get,
    /**
     * @vuese
     * Used to set props to varible
     */
    init() {
      this.employee = this.emp;
      this.listEducationTypes();
    },
    
    isOngoingEducation(endDate = null) {
      if ( !endDate )
        return ''

      const date = new Date().setDate(new Date().getDate() - 1)
      return Sugar.Date.isBefore(new Date(date), new Date(new Date(endDate)))
    },

    listEducationTypes() {
      API.listEducationTypes()
        .then((res) => {
          this.educationTypes = res.data;
        })
        .catch((error) => {
          console.log("error:", error);
        });
    },
    getYear(date) {
      if (!date) return "";
      return SugarDate.Date(date).format("%Y");
    },
    getEducationName(type) {
      if (type) {
        const et = find(this.educationTypes, { type: type });
        if (et && et.name) return et.name;
        else return "Ej angivet";
      } else {
        return "Ej angivet";
      }
    },
    displayName() {
      if (!this.employee) return;
      if (!this.employee.firstName && this.employee.email) return this.employee.email;

      return this.employee.firstName + " " + this.employee.lastName;
    },
  },
};
</script>
